import { type ComponentProps } from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import { listItemCheck, listItemVariants } from '../../../lib/list-styles'
import { ListItemText } from '../../../lib/list-item-text'
import { Check } from 'lucide-react'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxItemProps extends PartProps<ComponentProps<typeof Combobox.Item>> {
  className?: string
  showIndicator?: boolean
}

/**
 * The same row as Menu's and Select's. Children sit directly in the row, so a leading icon joins
 * the list's icon column; bare text gets the truncating label.
 */
function ComboboxItem({ className, children, showIndicator = true, ...props }: ComboboxItemProps) {
  const isText = typeof children === 'string' || typeof children === 'number'
  return (
    <Combobox.Item data-slot="list-item" className={twMerge(listItemVariants(), className)} {...props}>
      {isText ? <ListItemText>{children}</ListItemText> : children}
      {showIndicator && (
        <Combobox.ItemIndicator data-slot="list-item-check" className={listItemCheck}>
          <Check />
        </Combobox.ItemIndicator>
      )}
    </Combobox.Item>
  )
}

export { ComboboxItem }
